import { gql } from "@apollo/client";

/**
 * The backend nests the vehicle tree data below `keyNumber` and names the
 * generation-bearing node `type` (it resolves the `Type` model, i.e. the
 * motorization). The frontend keeps the vehicle tree wording, so this shape is
 * mapped to brand / generation / motorization in `getVehicle`.
 */
export type GetVehicleResponse = {
  organization: {
    Fleet: {
      GetVehicle: {
        keyNumber: {
          brand: {
            id: string;
            name: string;
            slug: string | null;
            logo: string | null;
          } | null;
          type: {
            id: string;
            name: string;
            isBev: boolean | null;
            generation: {
              id: string;
              name: string;
              slug: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export const GET_VEHICLE = gql`
  query getVehicle($organizationId: ID!, $contractNumber: String!) {
    organization(id: $organizationId) {
      id
      Fleet {
        GetVehicle(
          organization: $organizationId
          contractNumber: $contractNumber
        ) {
          keyNumber {
            brand {
              id
              name
              slug
              logo
            }
            type {
              id
              name
              isBev
              generation {
                id
                name
                slug
              }
            }
          }
        }
      }
    }
  }
`;
